import { render, staticRenderFns } from "./Searcher.vue?vue&type=template&id=641a9f3d&scoped=true&"
import script from "./Searcher.vue?vue&type=script&lang=js&"
export * from "./Searcher.vue?vue&type=script&lang=js&"
import style0 from "./Searcher.vue?vue&type=style&index=0&id=641a9f3d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a9f3d",
  null
  
)

export default component.exports